<template>
  <div class="simulacao-geral" v-if="isFabricio">
    <div class="card">
      <div class="card-header">
        <div class="header-content">
          <h3>Quadro Geral Preventivas - Simulação</h3>
          <router-link to="/importar-preventivas" class="btn btn-success">
            Importar Dados
          </router-link>
        </div>
        <div class="filtros">
          <div class="form-group">
            <label for="filtroFornecedor">Fornecedor</label>
            <select id="filtroFornecedor" class="form-control" v-model="filtroFornecedor">
              <option value="">Todos</option>
              <option v-for="fornecedor in fornecedores" :key="fornecedor" :value="fornecedor">{{ fornecedor }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="filtroUf">UF</label>
            <select id="filtroUf" class="form-control" v-model="filtroUf">
              <option value="">Todas</option>
              <option v-for="uf in ufs" :key="uf" :value="uf">{{ uf }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div v-if="carregando" class="loading">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
        </div>

        <div v-else-if="erro" class="alert alert-danger">
          {{ erro }}
        </div>

        <div v-else class="tabela-container">
          <table class="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th>Fornecedor</th>
                <th>Regional</th>
                <th>Descrição</th>
                <th>UF</th>
                <th v-for="(mes, index) in meses" :key="index">{{ mes }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dadosFiltrados" :key="index">
                <td>{{ item.fornecedor }}</td>
                <td>{{ item.regional }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ item.uf }}</td>
                <td v-for="(mes, mesIndex) in meses" :key="mesIndex">
                  {{ obterValorMes(item, mesIndex) }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colspan="4">Totais</th>
                <th v-for="(mes, index) in meses" :key="index">
                  {{ calcularTotalMes(index) }}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="resumo">
          <h4>Resumo por Fornecedor</h4>
          <div class="grafico-container">
            <canvas id="graficoFornecedores" ref="graficoFornecedores"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="alert alert-warning m-3">Acesso restrito.</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SimulacaoGeral',

  data() {
    return {
      env: process.env,
      dados: [],
      carregando: true,
      erro: null,
      meses: [
        'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
        'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
      ],
      fornecedores: [],
      ufs: [],
      filtroFornecedor: '',
      filtroUf: '',
      graficoInstance: null
    }
  },

  computed: {
    isFabricio() {
      try {
        const email = (this.$store.state.login.loginUsuario.usuario.email || '').toLowerCase()
        return email === 'fabricio.elias@portalssp.com'
      } catch (e) {
        return false
      }
    },
    dadosFiltrados() {
      let resultado = this.dados

      if (this.filtroFornecedor) {
        resultado = resultado.filter(item => item.fornecedor === this.filtroFornecedor)
      }

      if (this.filtroUf) {
        resultado = resultado.filter(item => item.uf === this.filtroUf)
      }

      return resultado
    }
  },

  created() {
    if (!this.isFabricio) {
      this.carregando = false
      this.erro = null
      return
    }
    this.carregarDados()
  },

  methods: {
    carregarDados() {
      this.carregando = true
      this.erro = null

      // Construir a URL com os filtros
      let url = `${this.env.FINANCEIRO.SLA}/simulacao-geral`
      const queryParams = []

      if (this.filtroFornecedor) {
        queryParams.push(`fornecedor=${encodeURIComponent(this.filtroFornecedor)}`)
      }

      if (this.filtroUf) {
        queryParams.push(`uf=${encodeURIComponent(this.filtroUf)}`)
      }

      if (queryParams.length > 0) {
        url += '?' + queryParams.join('&')
      }

      // Chamada real à API
      axios.get(url)
        .then(response => {
          if (response.data.success) {
            this.dados = response.data.dados
            this.fornecedores = response.data.fornecedores
            this.ufs = response.data.ufs

            // Inicializar o gráfico depois que os dados estiverem carregados
            this.$nextTick(() => {
              this.inicializarGrafico()
            })
          } else {
            this.erro = 'Erro ao carregar os dados'
          }
          this.carregando = false
        })
        .catch(error => {
          this.erro = 'Erro ao carregar os dados: ' + error.message
          this.carregando = false
        })
    },

    obterValorMes(item, mesIndex) {
      return item.valores[mesIndex] || 0
    },

    calcularTotalMes(mesIndex) {
      return this.dadosFiltrados.reduce((total, item) => {
        return total + (item.valores[mesIndex] || 0)
      }, 0)
    },

    inicializarGrafico() {
      // Buscar dados para o gráfico de resumo por fornecedor
      let url = `${this.env.FINANCEIRO.SLA}/simulacao-geral-resumo-fornecedor`

      if (this.filtroUf) {
        url += `?uf=${encodeURIComponent(this.filtroUf)}`
      }

      axios.get(url)
        .then(response => {
          if (response.data.success && response.data.dados) {
            // Aqui idealmente usaríamos Chart.js ou similar
            // Para este exemplo, apenas exibimos os dados
            console.log('Dados do gráfico:', response.data.dados)

            // Código para integração com Chart.js estaria aqui
            // Exemplo:
            // if (this.graficoInstance) {
            //   this.graficoInstance.destroy()
            // }
            // const ctx = this.$refs.graficoFornecedores.getContext('2d')
            // this.graficoInstance = new Chart(ctx, {
            //   type: 'bar',
            //   data: {
            //     labels: response.data.dados.map(item => item.fornecedor),
            //     datasets: [{
            //       label: 'Total de Preventivas',
            //       data: response.data.dados.map(item => item.total),
            //       backgroundColor: 'rgba(75, 192, 192, 0.2)',
            //       borderColor: 'rgba(75, 192, 192, 1)',
            //       borderWidth: 1
            //     }]
            //   },
            //   options: {
            //     scales: {
            //       y: {
            //         beginAtZero: true
            //       }
            //     }
            //   }
            // })
          }
        })
        .catch(error => {
          console.error('Erro ao carregar dados para o gráfico:', error)
        })
    },

    // Método para atualizar a visualização quando os filtros mudarem
    atualizarFiltros() {
      this.carregarDados()
    }
  },

  watch: {
    filtroFornecedor() {
      this.atualizarFiltros()
    },
    filtroUf() {
      this.atualizarFiltros()
    }
  }
}
</script>

<style scoped>
.simulacao-geral {
  padding: 20px;
}

.card {
  margin-bottom: 30px;
}

.card-header {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filtros {
  display: flex;
  gap: 15px;
}

.form-group {
  margin-bottom: 0;
}

.tabela-container {
  overflow-x: auto;
  margin-bottom: 30px;
}

table {
  min-width: 100%;
}

.loading {
  display: flex;
  justify-content: center;
  padding: 50px;
}

.grafico-container {
  height: 300px;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .filtros {
    margin-top: 15px;
    width: 100%;
  }

  .form-group {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// SimulacaoGeral.vue?b8770c3a